<template>
  <section id="footer">
    <div class="footerContent">
      <div class="links">
        <a @click.prevent="showTerms" href="#">{{$t('footer.termsAndConditions')}}</a>&nbsp;
        <a @click.prevent="showLegal" href="#">{{$t('footer.legalMentions')}}</a>&nbsp;
        <a @click.prevent="showContactForm" href="#">{{$t('footer.contact')}}</a>&nbsp;
      </div>
      <p>© Atelier-Sud {{ year }}</p>
      <div class="icons">
        <a href="https://www.facebook.com/profile.php?id=100009018029130" id="fbIcon">
          <font-awesome-icon :icon="['fab','facebook-f']"></font-awesome-icon>
        </a>
        <a href="https://twitter.com/Atelier_Sud" id="twitterIcon">
          <font-awesome-icon :icon="['fab','twitter']"></font-awesome-icon>
        </a>
        <a href="https://instagram.com" id="instagramIcon">
          <font-awesome-icon :icon="['fab','instagram']"></font-awesome-icon>
        </a>
      </div>
    </div>
    <modals-container>
      <modal name="contact-form" height="auto">
        <ContactForm />
      </modal>
    </modals-container>
  </section>
</template>

<script>
import ContactForm from "./modals/ContactForm.vue";
import TermsAndConditions from "./modals/TermsAndConditions.vue";
import LegalMentions from "./modals/LegalMentions.vue";

export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods: {
    showContactForm() {
      this.$modal.show(
        ContactForm,
        {},
        {
          scrollable: true,
          height: "auto",
          width: "75%"
        }
      );
    },
    showLegal() {
      this.$modal.show(
        LegalMentions,
        {},
        {
          scrollable: true,
          height: "auto",
          width: "75%"
        }
      );
    },
    showTerms() {
      this.$modal.show(
        TermsAndConditions,
        {},
        {
          scrollable: true,
          height: "auto",
          width: "75%",
          maxWidth: 600
        }
      );
    }
  },
  components: {
    ContactForm
  }
};
</script>

<style scoped>
a,
a:hover,
a:visited,
a:focus,
a:active {
  color: aliceblue;
}

a:hover {
  text-decoration: none;
  opacity: 0.8;
}

p {
  margin: 0;
}

.footerContent {
  text-align: center;
  padding: 40px 0 20px 0;
}

.icons {
  display: flex;
  justify-content: space-between;
  width: 70px;
  margin: auto;
  margin-top: 5px;
}

.v--modal {
  max-width: 600px !important;
}

#fbIcon:hover {
  color: #4267b2;
}

#twitterIcon:hover {
  color: #1da1f2;
}

#instagramIcon:hover {
  color: #dc2743;
}

#footer {
  background: #3b3b3c;
  color: #eeeeee;
  height: 10%;
  text-align: center;
  font-family: "Acre";
  font-size: 1rem;
  font-weight: 300;
  margin: auto;
}
</style>
